export default "__VITE_ASSET__BojUhiXH__"